import React from 'react';
import styled from 'styled-components';
import { colors } from './../../../tailwind';
import icon from '../../../../public/icons/search.svg';
import FontAwesome from 'react-icons/fa';

const InputLeft = styled.input`
  background-color: #ffffff;
  height: 42px;
  width: 100%
  border-radius: 19px 0px 0px 19px;
  background-color: #ffffff;
  border: solid 0px #6e6f71;
  border-right: solid 1px rgb(164, 167, 169);
  border-right: solid 1px rgba(164, 167, 169, .7);
  font-size: 20px;
  font-weight: light;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: ${colors.primaryDark};
  padding-left: 48px;

  &::placeholder {
    color: ${colors.coolGray};
    opacity: .7;
  }
`;

const InputRight = styled.input`
  background-color: #ffffff;
  height: 42px;
  width: 34%
  border-radius: 0px 4px 4px 0px;
  background-color: #ffffff;
  border: solid 0px #6e6f71;
  border-left: none;
  font-size: 20px;
  font-weight: light;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: ${colors.primaryDark};
  padding-left: 16px;

  &::placeholder {
    color: ${p =>
      p.searchParams && p.searchParams.lng ? colors.primary : colors.coolGray};
    opacity: .7;
  }
`;

const Icon = styled.img`
  position: absolute;
  width: 16px;
  height: 16px;
  top: 12px;
  left: 16px;
`;

export default function SearchInput(props) {
  let inputStyle = {
    display: 'flex',
    width: '100%',
    position: 'relative',
    maxWidth:'520px'
  };

  const { submit, searchParams } = props;

  // <Line />

  return (
    <div style={inputStyle}>
      <InputLeft
        placeholder="Search for an item"
        onChange={props.handleSearchChange}
        onKeyDown={e => e.keyCode === 13 && submit()}
      />
      <i
        className="fal fa-search"
        style={{
          position: 'absolute',
          fontSize: "18px",
          top: '12px',
          left: '12px',
          color: colors.primary,
        }}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components_new/common/FormComponents/SearchInput.js